import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Container } from '@material-ui/core';
import Page from 'src/components/Page';
import Header from 'src/components/Header';
import Todos from './Todos';
import Alert from '@material-ui/lab/Alert';
import ConcealableContainer from 'src/components/ConcealableContainer';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));

function UyariMerkezi() {
  const classes = useStyles();
  return (
    <Page className={classes.root} title="Uyarı Merkezi">
      <Container maxWidth="lg">
        <Header />        
        <Todos className={classes.todos} />
        <ConcealableContainer show={true}>
         <Alert severity="warning">{"Bu sayfada görüntüleme yapılmaktadır!.."}</Alert>
        </ConcealableContainer> 
      </Container>
    </Page>
  );
}

export default UyariMerkezi;
